
import { mdiOpenInNew } from '@mdi/js'
import { useStoryblokApi, useStoryblokBridge } from '@storyblok/nuxt-2'
import BlogArticle from '@/components/storyblok/blog/Article.vue'
import BlogArticleCard from '@/components/storyblok/blog/ArticleCard.vue'
import LandingpageToolbar from '@/components/layout/LandingpageToolbar.vue'

export default {
  name: 'ArticlePage',
  auth: false,
  components: {
    BlogArticle,
    BlogArticleCard,
    LandingpageToolbar,
  },
  layout: 'landingpage',
  data: () => ({
    mdiOpenInNew,
    story: null,
    others: [],
  }),
  async created() {
    try {
      const isDraft = this.$route.query?._storyblok !== undefined
      const storyblokApi = useStoryblokApi()
      const locale = this.$i18n.locale
      const version = isDraft ? 'draft' : 'published'
      const article = this.$route.params.article
      const { data } = await storyblokApi.get(
        `cdn/stories/blog/${article}?fallback_lang=de&language=${locale}`,
        {
          version,
        }
      )
      this.story = data.story

      if (this.story?.id && isDraft) {
        useStoryblokBridge(this.story.id, (evStory) => (this.story = evStory))
      }

      const otherArticles = await storyblokApi.get(
        `cdn/stories?fallback_lang=de&language=${locale}`,
        {
          version,
          starts_with: 'blog',
          excluding_stories: this.story.id,
        })
      this.others = otherArticles.data.stories
    } catch (err) {
      console.warn(err)
    }
  },
}
